module.exports = __webpack_public_path__ + "ai1.no2.bcc2f0e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/ai1.no2.jpg
// module id = 0C0e
// module chunks = 0